import { render, staticRenderFns } from "./model4.vue?vue&type=template&id=b649ea48&scoped=true"
import script from "./model4.vue?vue&type=script&lang=js"
export * from "./model4.vue?vue&type=script&lang=js"
import style0 from "./model4.vue?vue&type=style&index=0&id=b649ea48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b649ea48",
  null
  
)

export default component.exports